import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { organizationsApi } from '../../api/organizations';
import { GQLArgs } from '../../types';

type UpdateHospitalResponse = { updateOrganization: any };

export const useMutationUpdateHospital = (args?: GQLArgs<UpdateHospitalResponse>) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<UpdateHospitalResponse | undefined>();

  const mutation = useCallback(
    async ({
      variables,
      refetchQueries: _refetch,
    }: {
      variables: any;
      refetchQueries?: string[];
    }) => {
      setLoading(true);
      try {
        const res = await organizationsApi.update(variables.slug, {
          name: variables.name,
          logo_url: variables.logoUrl,
          parent_organization_slug: variables.parentOrganizationSlug,
          ref_id: variables.refId,
          active: variables.active,
          settings: variables.settings,
        });
        const o = res.data;
        const shaped: UpdateHospitalResponse = {
          updateOrganization: {
            name: o.name,
            logoUrl: o.logo_url,
            refId: o.ref_id,
            slug: o.slug,
            timeZone: o.time_zone,
            active: o.active,
            settings: o.settings,
            parent: null,
          },
        };
        setData(shaped);
        args?.onCompleted?.(shaped);
        toast.success('Settings has been updated', { autoClose: 5000 });
        return shaped;
      } catch (err: any) {
        args?.onError?.(err);
      } finally {
        setLoading(false);
      }
    },
    [args],
  );

  return { mutation, data, loading, error: undefined };
};
